import React, { Component } from 'react'
import { withRouter } from 'react-router-dom'
import PageTitle from '../../../../../shared/javascripts/components/PageTitle/PageTitle'
import asyncWrapper from '../../../../../shared/javascripts/hocs/asyncWrapper'
import Loading from '../../../../../shared/javascripts/components/Loading'
import Breadcrumbs from '../../../../../shared/javascripts/components/Breadcrumbs'

import OverallScore from './Scores/OverallScore'
import WeeklyScore from './Scores/WeeklyScore'
import GameScore from './Scores/GameScore'
import OverallCategoryMistakes from './Scores/OverallCategoryMistakes'
import CategoryMistakes from './Scores/CategoryMistakes'

import UserApi from '../../api/UserApi'

class UserReport extends Component {
  constructor(props) {
    super(props)
    this.state = {
      user: null,
    }
  }

  componentDidMount() {
    UserApi.fetchUser(this.props.match.params.userId)
      .then(this.props.handleErrors)
      .then(response => {
        this.setState({user: response},
          ()=>this.props.setLoading()
        )
      }).catch(error => console.log(error))
  }

  _findBreadcrumbs() {
    let { match } = this.props;
    let paths = [{name: 'Dashboard', path: '/'}]
    if(match.path.startsWith('/manager/')) { paths.push({name: 'Users', path: '/manager/users'})}

    return paths
  }

  render() {
    if(this.props.loading) { return <Loading />}
    let { user } = this.state;
    let breadcrumbPaths = this._findBreadcrumbs()

    return (
      <div className="User">
        <PageTitle title={`Scores for ${user.login}`} rightNav={<Breadcrumbs paths={breadcrumbPaths} />} /><hr />
        <OverallScore user={user} />
        <WeeklyScore user={user} />
        <GameScore user={user} />
        <OverallCategoryMistakes user={user} />
        <CategoryMistakes user={user} />
      </div>
    );
  }
}

export default asyncWrapper(withRouter(UserReport))


// WEBPACK FOOTER //
// ./src/reports/google_play/javascripts/components/User/UserReport.jsx